import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import * as Popups from '../../constants/popup-types';


class GetCustomerSurvey extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'GetCustomerSurvey';
        this.Config   = new AppConfig();
    }

    execute(dispatch,payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getCustomerSurvey,payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setSurvey(this.response.data));
    }

    onFailure(response){
        this.dispatch(Actions.addPopup({
            type: Popups.GENERAL_MESSAGE,
            text: response.err.content
        }));
    }
}


export default GetCustomerSurvey;